import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BackButton } from '../../common/BackButton';
import { useNavigate, useLocation } from 'react-router-dom';
import RichTextBox from '../client-setup/pages/faq/faq-manual/RichTextBox';
import { deleteFaq, getFaqList } from '../../api/AccountSetup';
import ToastNotification from '../../common/ToastNotification';
import { useGuideContext } from '../../Contexts/GuidingContext';
import { useMenuContext } from '../../Contexts/MenuContext';

const RETAIL_LIST = [
  {
    id: 1,
    name: 'FAQ',
    urlLink: '/settings/faq'
  },
  {
    id: 2,
    name: 'Widgets',
    urlLink: '/settings/widgets'
  },
  {
    id: 3,
    name: 'Profile',
    urlLink: '/settings/profile'
  },
  {
    id: 4,
    name: 'Integration',
    urlLink: '/settings/integration'
  },
  {
    id: 5,
    name: 'Users',
    urlLink: '/settings/users'
  },
  {
    id: 6,
    name: 'Configuration',
    urlLink: '/settings/configuration'
  },
  {
    id: 7,
    name: 'Subscription',
    urlLink: '/settings/subscription'
  }
];

const HOSPITALITY_LIST = [
  {
    id: 1,
    name: 'FAQ',
    urlLink: '/settings/faq'
  },
  {
    id: 2,
    name: 'Widgets',
    urlLink: '/settings/widgets'
  },
  {
    id: 3,
    name: 'Profile',
    urlLink: '/settings/profile'
  },
  {
    id: 4,
    name: 'Users',
    urlLink: '/settings/users'
  },
  {
    id: 5,
    name: 'Subscription',
    urlLink: '/settings/subscription'
  },
  {
    id: 6,
    name: 'Explore',
    urlLink: '/settings/menu'
  },
  {
    id: 7,
    name: 'Catalouge',
    urlLink: '/settings/catalouge'
  },
  {
    id: 8,
    name: 'Integration',
    urlLink: '/settings/integration'
  }
];

const OTHERS_LIST = [
  {
    id: 1,
    name: 'FAQ',
    urlLink: '/settings/faq'
  },
  {
    id: 2,
    name: 'Widgets',
    urlLink: '/settings/widgets'
  },
  {
    id: 3,
    name: 'Profile',
    urlLink: '/settings/profile'
  },
  {
    id: 4,
    name: 'Users',
    urlLink: '/settings/users'
  },
  {
    id: 5,
    name: 'Subscription',
    urlLink: '/settings/subscription'
  },
  {
    id: 6,
    name: 'Explore',
    urlLink: '/settings/menu'
  },
  {
    id: 7,
    name: 'Integration',
    urlLink: '/settings/integration'
  }
];

const SettingsSidebar = ({ children }: any) => {
  const businessType = sessionStorage.getItem('businessType');

  const navigate = useNavigate();
  const location = useLocation();
  const { currentStep, handleNextStep } = useGuideContext();
  const { menuList } = useMenuContext();

  const SettingsSidebarItems =
    businessType === 'Retail'
      ? RETAIL_LIST
      : businessType === 'Hospitality' && menuList.includes('Services')
        ? HOSPITALITY_LIST
        : OTHERS_LIST;

  const isActiveLink = (urlLink: string) => {
    return location.pathname.startsWith(urlLink);
  };

  return (
    <div className="md:flex bg-[#1E1E1E] text-white w-full  h-screen overflow-y-auto">
      <div className=" bg-[#1E1E1E] md:pt-4 md:pb-10 md:block hidden overflow-y-auto">
        <div className="flex md:gap-4 md:mb-[28px] ">
          <div className="sm:w-4 sm:h-4 mt-1">
            <BackButton onClick={() => navigate(-1)} />
          </div>
          <h2 className="md:text-lg sm:text-[10px] font-medium md:mt-1 md:ps-3 pt-2.5">Settings</h2>
        </div>
        <ul className="mt-4 border-r border-[#595959] h-[70%] md:w-[200px] w-[100px] md:ps-7">
          {SettingsSidebarItems.map((item, index) => (
            <li
              key={index}
              className={`relative md:w-[142px] md:h-[30px] md:text-[16px] sm:text-[12px] sm:me-2 text-left font-medium  ${
                isActiveLink(item.urlLink) ? 'bg-[#FFFFFF] text-[#006BEA] sm:mr-2 ' : ''
              } md:py-[4px] md:px-[8px] sm:text-[12px]  sm:me-2  flex items-center rounded-[5px]   mb-[18px]  `}
            >
              <Link
                to={item.urlLink}
                className={`sm:text-[12px] md:text-base sm:p-1.5 text-center sm:w-3 sm:hidden md:block ${item.name === 'Integration' && currentStep === 2 ? 'z-20' : ''}`}
              >
                {item.name !== 'Integration' && item.name}
                {item.name === 'Integration' ? (
                  <div onClick={() => handleNextStep(3)}>
                    {item.name}
                    {currentStep === 2 && (
                      <div className="absolute top-3 right-8">
                        <div className="absolute animate-ping w-5 h-5 rounded-full bg-gradient-to-r from-blue-400 to-[#006bea] opacity-20"></div>
                        <div className="relative w-3 h-3 rounded-full  bg-[#006bea]  "></div>
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                )}
              </Link>
              {item.name === 'Integration' && currentStep === 2 ? (
                <>
                  <div className="fixed inset-0 bg-black bg-opacity-50 z-10"></div>
                  <div className="relative z-20">
                    <div className="absolute w-[8rem] top-[12px] m-3">
                      <div role="alert" className="rounded-lg  bg-[#006BEA] p-3">
                        <h2 className="block font-normal text-[13px] text-[#FFFFFF]">
                          {' '}
                          Click on the integration button to get into the integration setup
                        </h2>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className=" bg-[#1E1E1E]  sm:block 640-767:block md:hidden sidebar-setting flex justify-center items-center self-center mb-2">
        <div className=" flex flex-row justify-center items-center w-full fixed top-9">
          {SettingsSidebarItems.map((item, index) => (
            <span
              key={index}
              className={`relative pr-2 text-left font-medium   ${
                isActiveLink(item.urlLink) ? 'bg-[#FFFFFF] text-[#006BEA]  ' : ''
              }  flex items-center rounded-[5px]   mb-[18px]  `}
            >
              <Link
                to={item.urlLink}
                className={`text-[10px]  ps-2 text-center  ${item.name === 'Integration' && currentStep === 2 ? 'z-20' : ''}`}
              >
                {item.name !== 'Integration' && item.name}
                {item.name === 'Integration' ? (
                  <div onClick={() => handleNextStep(3)}>
                    {item.name}
                    {currentStep === 2 && (
                      <div className="absolute top-2 right-0">
                        <div className="absolute animate-ping w-5 h-5 rounded-full bg-gradient-to-r from-blue-400 to-[#006bea] opacity-20"></div>
                        <div className="relative w-3 h-3 rounded-full  bg-[#006bea]  "></div>
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                )}
              </Link>
              {item.name === 'Integration' && currentStep === 2 ? (
                <>
                  <div className="fixed inset-0 bg-black bg-opacity-50 z-10"></div>
                  <div className="relative z-20">
                    <div className="absolute w-[10rem] top-[1rem] right-0">
                      <div role="alert" className="rounded-lg  bg-[#006BEA] p-3">
                        <h2 className="block font-normal text-sm text-[#FFFFFF] z-50">
                          {' '}
                          Click on the integration button to get into the integration setup
                        </h2>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}
            </span>
          ))}
        </div>
      </div>

      <div className="md:mt-16 overflow-y-auto overflow-x-hidden mb-[70px] flex-col w-full flex-1 flex-grow">
        {children}
      </div>
    </div>
  );
};

export default SettingsSidebar;
